import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { AlertService } from 'services/alert.service';
import { FriendDetailsService } from 'services/frienddetails.service';
import { NavigationService } from 'services/navigation.service';
import swal from 'sweetalert2';
import { UserService } from 'services/user.service';
import { clear } from 'console';

@Component({
  selector: 'app-manage-referral',
  templateUrl: './manage-referral.component.html',
  styleUrls: ['./manage-referral.component.scss']
})
export class ManageReferralComponent implements OnInit {

  data: any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    'referrerName',
    'referrerEmail',
    'referrerMobile',
    'friendName',
    'friendEmail',
    'friendMobile',
    'friendAppNumber',
    'friendReferralStatusType',
    'action'
  ];


  // Filter UI state
  filterOpen: boolean = false;
  fromDate: string = null;
  toDate: string = null;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  mobileView: boolean;
  filterValue: string;
  userId: string[] = [];
  IsShowPayBt: boolean = false;

  constructor(private friendDetailService: FriendDetailsService,
    public navigationService: NavigationService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private router: Router,) { }

  ngOnInit() {
    this.getReferredUserList();
    this.filterValue = '';
    this.mobileView = false;
  }

  toggleFilter() {
    this.filterOpen = !this.filterOpen;
  }

  applyDateFilter() {

    if ((this.fromDate == null || this.fromDate == undefined) && (this.toDate == null || this.toDate == undefined)) {
      this.alertService.warning('Please select Start Date and End Date to apply filter');
    }

    if (this.fromDate == null || this.fromDate == undefined) {
      this.alertService.warning('Please select Start Date to apply filter');
      return;
    }

    if (this.toDate == null || this.toDate == undefined) {
      this.alertService.warning('Please select End Date to apply filter');
      return;
    }

    let from = this.fromDate ? new Date(this.fromDate) : null;
    let to = this.toDate ? new Date(this.toDate) : null;
    if (from) from.setHours(0, 0, 0, 0);
    if (to) to.setHours(23, 59, 59, 999);

    const fromISO = from ? from.toISOString() : null;
    const toISO = to ? to.toISOString() : null;

    this.friendDetailService.getReferredUserListByDateFilter(fromISO, toISO).subscribe(result => {
      const list = (result) ? result : [];
      console.debug('getReferredUserListByDateFilter returned', list);
      this.dataSource = new MatTableDataSource(list);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      if ((this.dataSource as any)._updateChangeSubscription) (this.dataSource as any)._updateChangeSubscription();
      this.cdr.detectChanges();
    }, err => {
      this.alertService.error('Could not apply date filter');
    });
  }

  clearDateFilter() {
    this.fromDate = null;
    this.toDate = null;
    // this.getReferredUserList();
  }
  getReferredUserList() {
    this.friendDetailService.getReferredUserList().subscribe(result => {
      const list = (result && result.value) ? result.value : (result || []);
      console.debug('getReferredUserList returned', list);
      this.data = list;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      // Force table update and change detection in case template doesn't refresh automatically
      if ((this.dataSource as any)._updateChangeSubscription) {
        (this.dataSource as any)._updateChangeSubscription();
      }
      this.cdr.detectChanges();
    }, err => {
      this.alertService.error('Could not load referred user list');
    });

  }

  getReferredUserBySearch(filter) {
    if (this.filterValue == null || this.filterValue == undefined || this.filterValue == '') {
      this.alertService.warning('Please enter search value to apply filter');
      return;
    }

    this.clearDateFilter();
    this.filterOpen = false;
    this.friendDetailService.getReferredUserBySearch(filter).subscribe(result => {
      const list = (result && result.value) ? result.value : (result || []);
      console.debug('applyFilter returned', list);
      this.data = list;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      if ((this.dataSource as any)._updateChangeSubscription) {
        (this.dataSource as any)._updateChangeSubscription();
      }
      this.cdr.detectChanges();
    }, err => {
      this.alertService.error('Filter failed');
    });
  }

  onFilter() {
    if (this.filterValue == null || this.filterValue == undefined || this.filterValue == '') {
      this.alertService.warning('Please enter search value to apply filter');
      return;
    }
    this.getReferredUserBySearch(this.filterValue);
  }

  applyFilter(filterValue: string) {
    this.filterValue = filterValue.trim();
  }

  onRefresh() {
    this.IsShowPayBt = false;
    this.userId = [];
    this.filterValue = '';
    this.getReferredUserList();
  }


  onKeydown(event) {
    if (event.key === "Enter") {
      this.getReferredUserBySearch(this.filterValue);
    }
  }

  exportToCsv() {

    var rows = this.data;
    if (!rows || rows.length === 0) {
      this.alertService.warning('No data available to export');
      return;
    }

    const headers = [
      'Referrer Name', 'Referrer Email', 'Referrer Mobile',
      'Referee Name', 'Referee Email', 'Referee Mobile', 'Referee Application Number', 'Referee Status'
    ];

    const fields = ['referrerName', 'referrerEmail', 'referrerMobile', 'friendName', 'friendEmail', 'friendMobile', 'friendAppNumber', 'friendReferralStatusTypeDesc'];

    const csvLines = [];
    csvLines.push(headers.join(','));

    const esc = (val: any) => {
      const s = (val === null || val === undefined) ? '' : String(val);
      return '"' + s.replace(/"/g, '""') + '"';
    };

    rows.forEach(row => {
      var r = {
        referrerName: row.referrerName || '',
        referrerEmail: row.referrerEmail || '',
        referrerMobile: row.referrerMobile || '',
        friendName: row.friendName || '',
        friendEmail: row.friendEmail || '',
        friendMobile: row.friendMobile || '',
        friendAppNumber: row.friendAppNumber || '',
        friendReferralStatusTypeDesc: row.friendReferralStatusTypeDesc || ''
      };
      const line = fields.map(f => esc(r[f])).join(',');
      csvLines.push(line);
    });


    const csv = csvLines.join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = 'manage_referral_export_' + (new Date()).toISOString().slice(0, 10) + '.csv';
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }


  markAsPaid(data) {
    swal.fire({
      html: `Are you sure you want to mark this as PAID ?`,
      icon: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Ok',
    }).then((res) => {
      if (res.value) {
        this.paidCall(data);
      }
    });
  }

  paidCall(data) {
    this.friendDetailService.markAsPaid(data).subscribe(result => {
      if (result) {
        this.alertService.success("Successfully marked as Paid");
        this.onRefresh();
      }
      else {
        this.alertService.error('Failed to mark as paid');
      }
    }, err => {
      this.alertService.error('Failed to mark as paid');
    });
  }

  onCheckBoxChange(event, id) {

    const index = this.userId.indexOf(id.friendDetailsId, 0);
    if (event.checked === true) {
      this.userId.push(id.friendDetailsId);
    }
    else if (event.checked === false) {
      if (index > -1) {
        this.userId.splice(index, 1);
      }
    }

    if (this.userId.length > 0)
      this.IsShowPayBt = true;
    else
      this.IsShowPayBt = false;

  }

  onBatchPayment() {

    if (this.userId.length > 0) {
      const data = { Id: this.userId };
      this.userService.postPayoutBatch(data).subscribe(result => {

        if (result.value) {
          this.IsShowPayBt = false;
          this.userId = [];
          this.onRefresh();
          this.alertService.success("Payment request sent successfully");

        }
        else {
          this.alertService.error(result.htmlFormattedFailures);
        }
      });
    }
    else {
      swal.fire({
        text: "Please Select User In Grid",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Ok',
      }).then((res) => {
        if (res.value) {

        }
      });
    }

  }
}
